import React, { useEffect, useRef } from "react";
import { Helmet } from "react-helmet-async";
import Hero from "./Sections/Hero";
import ContactInfo from "./Sections/ContactInfo";
import Form from "./Sections/Form";
// fetching
import useFetch from "Hooks/useFetch";
import IsLoading from "Components/RequestHandler/IsLoading";
import IsError from "Components/RequestHandler/IsError";

const Contact = () => {
  const { data, loading, error } = useFetch("contact-us");
  const formRef = useRef(null); // Create a reference for the form element

  useEffect(() => {
    // Function to scroll to the form
    const scrollToForm = () => {
      formRef.current.scrollIntoView({ behavior: "smooth" });
    };

    // Scroll to the form when data is loaded
    if (!loading && !error && data) {
      scrollToForm();
    }
  }, [data, loading, error]);

  if (loading) return <IsLoading />;
  else if (error) return <IsError />;
  if (data) {
    const contactData = data?.contactus;
    const heroData = contactData?.hero;
    const contactListData = contactData?.list;
    const meta = contactData?.meta;
    return (
      <main>
        <Helmet>
          <title>{meta?.meta_title}</title>
          <meta name="description" content={meta?.meta_description} />
          <meta name="keywords" content={meta?.meta_keywords} />
        </Helmet>
        <Hero data={heroData} />
        <ContactInfo data={contactListData} />
        <div ref={formRef}>
          <Form /> {/* Pass the ref to the Form component */}
        </div>
      </main>
    );
  }
};

export default Contact;
